import { render, staticRenderFns } from "./MenuPhone.vue?vue&type=template&id=76f3e58c&scoped=true"
import script from "./MenuPhone.vue?vue&type=script&lang=js"
export * from "./MenuPhone.vue?vue&type=script&lang=js"
import style0 from "./MenuPhone.vue?vue&type=style&index=0&id=76f3e58c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f3e58c",
  null
  
)

export default component.exports